/** Fixed editorial vocabulary; labels are metadata, never synthesis settings. */
export const VOICE_QUALITIES = [
  "Approachable", "Articulate", "Bright", "Calm", "Clear", "Comforting",
  "Confident", "Conversational", "Crisp", "Curious", "Deep", "Direct", "Eager",
  "Empathic", "Energetic", "Engaging", "Fast-paced", "Friendly", "Fun", "Helpful",
  "Intimate", "Natural", "Precise", "Professional", "Reassuring", "Relaxed",
  "Resonant", "Soothing", "Unhurried", "Velvety", "Warm", "Youthful",
] as const;
export type VoiceQuality = typeof VOICE_QUALITIES[number];
const record = (value: unknown): Record<string, unknown> =>
  value && typeof value === "object" && !Array.isArray(value) ? value as Record<string, unknown> : {};
const patterns = VOICE_QUALITIES.map(quality => ({ quality, pattern: new RegExp(`(^|[^\\p{L}\\p{N}])${quality.toLowerCase()}($|[^\\p{L}\\p{N}])`, "u") }));
export function qualitiesFromDescription(description: unknown): VoiceQuality[] {
  if (typeof description !== "string") return [];
  const text = description.toLowerCase().replace(/[\u2010-\u2015\u2212]/g, "-");
  return patterns.filter(({ pattern }) => pattern.test(text)).map(({ quality }) => quality);
}
export function descriptionQualities(metadata: unknown): VoiceQuality[] {
  const meta = record(metadata);
  return qualitiesFromDescription(record(meta.catalog).description);
}
export function voiceQualities(metadata: unknown): VoiceQuality[] {
  const overrides = record(record(metadata).catalog_overrides);
  // An explicit empty array is intentional, not a request to infer again.
  if (Object.hasOwn(overrides, "qualities")) {
    const saved = overrides.qualities;
    return Array.isArray(saved) ? VOICE_QUALITIES.filter(quality => saved.includes(quality)) : [];
  }
  return descriptionQualities(metadata);
}
